import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState: any = {
  shopList: {},
};

const HomeThreeSlice = createSlice({
  name: 'homeThree',
  initialState,
  reducers: {
    setShopList: (state, action: any) => {
      state.shopList = action.payload;
    },
  },
});

export const { setShopList } = HomeThreeSlice.actions;

export default HomeThreeSlice.reducer;
